import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import InfiniteScroll from "react-infinite-scroll-component";
import SmallLoading from "../../../globalComponents/Loading/components/SmallLoading/SmallLoading";
import RoomCalendarCard from "./RoomCalendarCard";

const RoomCalendarData = ({ getNextData }) => {
  const { calendarData, rooms, hasMore } = useSelector(
    (state) => state.roomsCalendarPagination
  );

  const { user } = useSelector((state) => state.user);

  const [scrollHeight, setScrollHeight] = useState(1);

  const tableHead = [
    { id: 1, label: "" },
    { id: 2, label: "" },
    ...rooms?.map((room, i) => ({ id: i + 3, label: room.name })),
    "",
  ];

  useEffect(() => {
    const mainHeader = document.querySelector(".main-header");
    const detailsHeader = document.querySelector(".details-header");

    const handleResize = () => {
      setScrollHeight(
        window.innerHeight -
          mainHeader.offsetHeight -
          detailsHeader.offsetHeight
      );
    };

    setScrollHeight(
      window.innerHeight - mainHeader.offsetHeight - detailsHeader.offsetHeight
    );

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <InfiniteScroll
        style={{ overflowX: "none", backgroundColor: "var(--neutrals-200)" }}
        dataLength={calendarData.length}
        next={getNextData}
        hasMore={hasMore}
        loader={<SmallLoading />}
        endMessage={<p style={{ textAlign: "center", fontSize: "20px" }}></p>}
        scrollThreshold={0.7}
        height={scrollHeight}
      >
        <table
          className={`details-table  events-table ${
            user?.power === "only-show" ? "only-show" : "update"
          } `}
          style={{ minWidth: "100%" }}
        >
          <thead>
            <tr>
              {tableHead.map((head, i) => (
                <th
                  className={`table-head-w `}
                  key={i}
                  style={{
                    minWidth:
                      i < 2
                        ? "150px"
                        : i + 1 < tableHead.length
                        ? "300px"
                        : "0px",
                    textAlign: "center",
                  }}
                >
                  {head.label}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {calendarData.length > 0 && (
              <tr
                className="class-table"
                style={{
                  position: "sticky",
                  top: "45px",
                  backgroundColor: "var(--neutrals-200)",
                  zIndex: 1,
                }}
              >
                <td>
                  <div className="td-con">
                    <div className="table-scroll-text">Tarix</div>
                  </div>
                </td>
                <td>
                  <div className="td-con">
                    <div className="table-scroll-text">Gün</div>
                  </div>
                </td>
                {rooms?.map((room) => (
                  <td key={room._id} style={{ padding: "0", width: "300px" }}>
                    <div
                      style={{
                        display: "table",
                        width: "100%",
                        height: "100%",
                        tableLayout: "fixed",
                      }}
                    >
                      <div style={{ display: "table-row" }}>
                        <div
                          style={{
                            display: "table-cell",
                            width: "33.333%",
                            padding: " 12px",
                            textAlign: "center",
                            borderRight: "1px solid #ddd",
                          }}
                        >
                          10:00
                        </div>
                        <div
                          style={{
                            display: "table-cell",
                            width: "33.333%",
                            padding: " 12px",
                            textAlign: "center",
                            borderRight: "1px solid #ddd",
                          }}
                        >
                          15:00
                        </div>
                        <div
                          style={{
                            display: "table-cell",
                            width: "33.333%",
                            padding: " 12px",
                            textAlign: "center",
                            borderRight: "1px solid #ddd",
                          }}
                        >
                          19:00
                        </div>
                      </div>
                    </div>
                  </td>
                ))}
                <td></td>
              </tr>
            )}
            {calendarData?.map((data, i) => (
              <RoomCalendarCard
                key={data.date}
                data={data}
                mode="desktop"
                cellNumber={i + 1}
              />
            ))}
          </tbody>
        </table>
      </InfiniteScroll>
    </>
  );
};

export default RoomCalendarData;
